var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWithdraw16 = function SvgIconWithdraw16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-textPrimary, #23024D)",
    strokeLinecap: "square",
    d: "M10.667 5.667 8 3 5.333 5.667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-textPrimary, #23024D)",
    d: "M8 3.334v6.833"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-textPrimary, #23024D)",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    d: "M2.667 10v2.333A1.333 1.333 0 0 0 4 13.667h8a1.333 1.333 0 0 0 1.333-1.334V10"
  })));
};
export default SvgIconWithdraw16;